module.exports = __webpack_public_path__ + "img/no-data.9cccb0e6.png";